import { storeAsync } from '@/app-module';
import PermissionChecker from '@/security/permission-checker';
import { routerAsync } from '@/app-module';

export default {
    async beforeRouteEnter(to, from, next) {
        if (!to.meta || (!to.meta.permission && !to.meta.permissions)) {
            next();
            return;
        }
        
        const store = storeAsync();
        await store.dispatch('auth/doWaitUntilInit');
        const permissionChecker = new PermissionChecker(
            store.getters['auth/accountDetails']
        );
        const hasPermission = to.meta.permission
            ? permissionChecker.match(to.meta.permission)
            : false;

        const hasAnyPermission = to.meta.permissions
            ? to.meta.permissions.some((permission) =>
                permissionChecker.match(permission)
            )
            : false;       
        if (
            hasPermission || hasAnyPermission
        ) {
            next();
        } else {
            const router = routerAsync();
            router.replace({ name: 'home' });
        }
    }
};
